<template>
    <div class="main-center" style="margin-top: 95px;height: 100%">
        <div class="bkElement">
            <!--中谷物流外贸修箱报价查询-->
            <p class="bkTitle">{{$t("repairTrack.title")}}</p>
        </div>
        <div>
            <div>
                <div class="flex flex-space-around">
                    <div class="inputName">
                        <el-input :placeholder="$t('common.pleaseEnter')" v-model="blNo" class="input-with-select" style="width: 350px">
                            <template slot="prepend">提单号</template>
                        </el-input>
                    </div>
                    <div class="inputName">
                        <el-input :placeholder="$t('common.pleaseEnter')" v-model="containerNo" class="input-with-select" style="width: 350px">
                            <template slot="prepend">箱号</template>
                        </el-input>
                    </div>
                    <div class="inputName"></div>
                    <div class="inputName"></div>
                    <div class="searchBtn">
                        <el-button @click="searchBtnClick" style="background-color: #ee2c2c; color: white"
                                   icon="el-icon-search">{{trackSearchButton}}
                        </el-button>
                        <el-button icon="el-icon-refresh"
                                   @click="resetBtnClick">
                            {{resetButton}}
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showNoDataView" class="noData">
            <no-data-view/>
        </div>

        <!--查询结果-->
        <div v-if="!showNoDataView" class="searchList">
            <div class="cardBody" v-for="(i,j) in repairTrackInfos" :key="j">
                <!--修箱信息-->
                <div>
                    <i class="el-icon-s-order" style="color: #BC1920"></i>
                    <span class="bkTitle2">{{$t('repairTrack.repairInfo')}}</span>
                </div>
                <div>
                    <el-row>
                        <div class="span-group">
                            <!--估价单号-->
                            <el-col style="width: 50%">
                                <span class="span-left">{{$t('repairTrack.estimateNo')}}：</span>
                                <span>{{i.estimateNo}}</span>
                            </el-col>
                            <!--提单号-->
                            <el-col style="width: 50%">
                                <span class="span-left">{{$t('repairTrack.blNo')}}：</span>
                                <span>{{i.blNo}}</span>
                            </el-col>
                        </div>
                    </el-row>
                    <el-row>
                        <div class="span-group">
                            <!--箱号-->
                            <el-col style="width: 50%">
                                <span class="span-left">{{$t('repairTrack.containerNo')}}：</span>
                                <span>{{i.containerNo}}</span>
                            </el-col>
                            <!--申请日期-->
                            <el-col style="width: 50%">
                                <span class="span-left">{{$t('repairTrack.applyDate')}}：</span>
                                <span>{{i.applyDate}}</span>
                            </el-col>
                            <!--&lt;!&ndash;修箱公司名称&ndash;&gt;
                            <el-col style="width: 50%">
                                <span class="span-left">{{$t('repairTrack.repairCompany')}}：</span>
                                <span>{{i.repairCompanyNameCn}}</span>
                            </el-col>-->
                        </div>
                    </el-row>
                    <el-row>
                        <div class="span-group">
                            <!--修理金额-->
                            <el-col style="width: 50%">
                                <span class="span-left">{{$t('repairTrack.actualAmount')}}：</span>
                                <span>{{i.actualAmount}}</span>
                            </el-col>
                            <!--币种-->
                            <el-col style="width: 50%">
                                <span class="span-left">{{$t('repairTrack.currency')}}：</span>
                                <span>{{i.currency}}</span>
                            </el-col>
                        </div>
                    </el-row>
                    <el-row>
                        <div class="span-group">
                            <!--完成日期-->
                            <el-col style="width: 50%">
                                <span class="span-left">{{$t('repairTrack.factFinalDate')}}：</span>
                                <span>{{i.factFinalDate}}</span>
                            </el-col>
                            <!--修理地点 -->
                            <el-col style="width: 50%">
                                <span class="span-left">{{$t('repairTrack.repairPlace')}}：</span>
                                <span>{{getCurLanguage() == 'en' ? i.repairPlaceName : i.repairPlaceNameCn}}</span>
                            </el-col>
                        </div>
                    </el-row>
                    <el-row>
                        <div class="span-group">
                            <el-col>
                                <span class="span-left">{{$t('repairTrack.repairCompany')}}：</span>
                                <span>{{getCurLanguage() == 'en' ? i.repairCompanyName : i.repairCompanyNameCn}}</span>
                            </el-col>
                        </div>
                    </el-row>
                </div>
                <p/>
                <!--收退费信息-->
                <div>
                    <i class="el-icon-s-finance" style="color: #BC1920"></i>
                    <span class="bkTitle2">{{$t("repairTrack.receiveAndRefund")}}</span>
                </div>
                <div class="mainTable">
                    <el-table :data="i.repairTrackCustomerCharges" style="width:100%"
                              :header-cell-style="{background:'#E9E9E9',height:'36px'}"
                              :row-style="{height:'40px'}"
                              :cell-style="{padding:'0px'}" max-height="600" highlight-current-row
                              class="voyageTable" :empty-text="$t('common.noData')">
                        <el-table-column min-width="60" type="index" :label="$t('estimateDetails.estimateCustomerCharge.index')" align="center"></el-table-column>
                        <!--收费日期-->
                        <el-table-column min-width="150" show-overflow-tooltip prop="receiveDate"
                                         :label="$t('estimateDetails.estimateCustomerCharge.receiveDate')" align="center">
                        </el-table-column>
                        <!--收费金额-->
                        <el-table-column min-width="150" show-overflow-tooltip prop="receiveAmount"
                                         :label="$t('estimateDetails.estimateCustomerCharge.receiveAmount')" align="center">
                        </el-table-column>
                        <!--退费日期-->
                        <el-table-column min-width="150" show-overflow-tooltip prop="refundDate"
                                         :label="$t('estimateDetails.estimateCustomerCharge.refundDate')" align="center"></el-table-column>
                        <!--退费金额-->
                        <el-table-column min-width="150" show-overflow-tooltip prop="refundAmount"
                                         :label="$t('estimateDetails.estimateCustomerCharge.refundAmount')"
                                         align="center"></el-table-column>
                        <!--收退费说明-->
                        <el-table-column min-width="150" show-overflow-tooltip prop="remark"
                                         :label="$t('estimateDetails.estimateCustomerCharge.remark')" align="center"></el-table-column>
                        <!--币种-->
                        <el-table-column min-width="90" show-overflow-tooltip prop="currency"
                                         :label="$t('estimateDetails.estimateCustomerCharge.currency')" align="center">
                        </el-table-column>
                    </el-table>
                </div>

                <!--&lt;!&ndash;修箱信息&ndash;&gt;
                <el-descriptions :title="$t('repairTrack.repairInfo')" :column=3 style="margin-top: 15px"
                                 content-class-name="descriptions_class"
                                 label-class-name="labels_class">
                    &lt;!&ndash;估价单号&ndash;&gt;
                    <el-descriptions-item :label="$t('repairTrack.estimateNo')">{{i.estimateNo}}</el-descriptions-item>
                    &lt;!&ndash;提单号&ndash;&gt;
                    <el-descriptions-item :label="$t('repairTrack.blNo')">{{i.blNo}}</el-descriptions-item>
                    &lt;!&ndash;箱号&ndash;&gt;
                    <el-descriptions-item :label="$t('repairTrack.containerNo')">
                        <el-tag size="small">{{i.containerNo}}</el-tag>
                    </el-descriptions-item>
                    &lt;!&ndash;修箱公司名称&ndash;&gt;
                    <el-descriptions-item :label="$t('repairTrack.repairCompany')">{{i.repairCompany}}</el-descriptions-item>
                    &lt;!&ndash;修理地点&ndash;&gt;
                    <el-descriptions-item :label="$t('repairTrack.repairPlace')">{{i.repairPlace}}</el-descriptions-item>
                    &lt;!&ndash;申请日期&ndash;&gt;
                    <el-descriptions-item :label="$t('repairTrack.applyDate')">{{i.applyDate}}</el-descriptions-item>
                    &lt;!&ndash;修理金额&ndash;&gt;
                    <el-descriptions-item :label="$t('repairTrack.actualAmount')">{{i.actualAmount}}</el-descriptions-item>
                    &lt;!&ndash;完成日期&ndash;&gt;
                    <el-descriptions-item :label="$t('repairTrack.factFinalDate')">{{i.factFinalDate}}</el-descriptions-item>
                </el-descriptions>
                &lt;!&ndash;收退费信息&ndash;&gt;
                <el-descriptions :title="$t('repairTrack.receiveAndRefund')"/>
                <div class="mainTable">
                    <el-table :data="i.repairTrackCustomerCharges" style="width:100%"
                              :header-cell-style="{background:'#E9E9E9',height:'36px'}"
                              :row-style="{height:'40px'}"
                              :cell-style="{padding:'0px'}" max-height="600" highlight-current-row
                              class="voyageTable" :empty-text="$t('common.noData')">
                        <el-table-column min-width="60" type="index" :label="$t('estimateDetails.estimateCustomerCharge.index')" align="center"></el-table-column>
                        &lt;!&ndash;收费日期&ndash;&gt;
                        <el-table-column min-width="150" show-overflow-tooltip prop="receiveDate"
                                         :label="$t('estimateDetails.estimateCustomerCharge.receiveDate')" align="center">
                        </el-table-column>
                        &lt;!&ndash;收费金额&ndash;&gt;
                        <el-table-column min-width="150" show-overflow-tooltip prop="receiveAmount"
                                         :label="$t('estimateDetails.estimateCustomerCharge.receiveAmount')" align="center">
                        </el-table-column>
                        &lt;!&ndash;退费日期&ndash;&gt;
                        <el-table-column min-width="150" show-overflow-tooltip prop="refundDate"
                        :label="$t('estimateDetails.estimateCustomerCharge.refundDate')" align="center"></el-table-column>
                        &lt;!&ndash;退费金额&ndash;&gt;
                        <el-table-column min-width="150" show-overflow-tooltip prop="refundAmount"
                        :label="$t('estimateDetails.estimateCustomerCharge.refundAmount')"
                        align="center"></el-table-column>
                        &lt;!&ndash;收退费说明&ndash;&gt;
                        <el-table-column min-width="150" show-overflow-tooltip prop="remark"
                        :label="$t('estimateDetails.estimateCustomerCharge.remark')" align="center"></el-table-column>
                        &lt;!&ndash;币种&ndash;&gt;
                        <el-table-column min-width="90" show-overflow-tooltip prop="currency"
                                         :label="$t('estimateDetails.estimateCustomerCharge.currency')" align="center">
                        </el-table-column>
                    </el-table>
                </div>-->
            </div>

        </div>
        <div class="footerSpan" style="margin-top: 200px">
            <span></span>
        </div>
    </div>
</template>

<script>
    import noDataView from "@/components/noDataView";

    export default {
        name: "cargoTrack",
        computed: {
            trackSearchButton() {
                return this.$t("repairTrack.repairSearchButton");
            },
            resetButton() {
                return this.$t("common.resetButton");
            },
            // 提单号查询条件
            blNo: {
                get: function () {
                    return this.search.blNo;
                },
                set: function (val) {
                    this.search.blNo = val.toUpperCase();
                }
            },
            // 箱号查询条件
            containerNo: {
                get: function () {
                    return this.search.containerNo;
                },
                set: function (val) {
                    this.search.containerNo = val.toUpperCase();
                }
            },
        },
        components: {
            noDataView
        },
        data() {
            return {
                //控制按钮重复点击
                isSelectClick: false,
                showNoDataView: true,
                search: {
                    blNo: "",
                    containerNo: ""
                },
                repairTrackInfos: [],
            }
        },
        mounted() {

        },
        methods: {
            searchBtnClick() {
                if(this.isSelectClick){
                    return;
                }
                //校验查询条件是否为空
                if (this.search.blNo == "" && this.search.containerNo == "") {
                    this.showMessage(false, this.$t("message.enterAtLeastOne"), "warning");
                    return
                }

                //显示进度条
                // 声明一个loading对象
                this.loadingtuo = this.$loading({
                    lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                    text: this.$t('message.searching'),    //加载动画的文字
                    spinner: 'el-icon-loading',             // 引入的loading图标
                    background: "rgb(0,0,0,0.1)",
                });
                let that = this;
                this.isSelectClick = true;

                this.axios({
                    method: "post",
                    url: "/api/equipment/getRepairInformation",
                    data: {
                        blNo: this.search.blNo,
                        containerNo: this.search.containerNo,
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale"),
                        'Content-type': 'application/json;charset=utf-8'
                    }
                }).then(response => {
                    if (response.data.backCode === "200") {
                        if(response.data.object && response.data.object.length > 0){
                            this.showNoDataView = false;
                            this.repairTrackInfos = response.data.object;
                        }else{
                            this.showNoDataView = true;
                        }
                    } else {
                        this.showNoDataView = true;
                        this.responseCode = response.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    }
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
                that.loadingtuo.close();
                this.isSelectClick = false;

            },
            resetBtnClick(){
                this.search.blNo = "";
                this.search.containerNo = "";
            },
            getCurLanguage() {
                return localStorage.getItem('locale');
            },
        }
    }
</script>

<style lang="scss">

    .bkTitle {
        font-size: 25px;
        margin: 20px auto;
        font-weight: bold;
    }

    .bkTitle2 {
        width: 80%;
        font-size: 19px;
    }

    .queryType {
        border: 0;
        width: 150px;

        .el-input {
            input {
                color: #fff;
                background-color: #EE2C2C;
                font-size: 15px;
            }
        }
    }

    .input-group {
        position: relative;
        display: table;
        border-collapse: separate;
    }

    .ydhTxt {
        font-size: 15px;
        width: 400px;
    }

    .searchButton {
        font-size: 15px;
        background-color: #ee2c2c;
        color: #fff;
        border-color: transparent;
    }

    .noData {
        height: 100%;
        margin: 15px 0;
        background-color: #ffffff;
    }

    .noData2 {
        margin-left: 50px;
        height: 100%;
        background-color: #ffffff;
    }

    .searchList {
        margin: 15px 0;
    }

    .span-group {
        flex: 1;
        border: 0;
        line-height: 44px;
        height: 40px;
        margin-left: 50px;
    }

    .span-left {
        width: 150px;
    }

    .span-right {
        width: 500px;
    }

    .searchBtn {
        display: flex;
        flex: 1;
        justify-content: flex-end;
        margin: 0 5px;
    }

    .el-input-group__append, .el-input-group__prepend {
        background-color: #ee2c2c;
        color: #fff;
        vertical-align: middle;
        display: table-cell;
        position: relative;
        border: 1px solid #DCDFE6;
        border-radius: 4px;
        padding: 0 20px;
        width: 1px;
        white-space: nowrap;
    }

</style>
<style lang="scss" scoped>
    .el-descriptions__body .el-descriptions__table {
        border-collapse: collapse;
        width: 100%;
        table-layout: fixed;
        background-color: #F6F6F6;
    }

    .el-descriptions__title {
        font-size: 18px;
        font-weight: bold;
    }

    .labels_class {
        font-size: 15px;
        margin-left: 30px;
        color: black;
    }

    .descriptions_class {
        font-size: 15px;
        margin-left: 5px;
        color: black;
        width: 200px;
    }
</style>